import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes, View } from '@components';
import { getConexoes, reset as resetConexoes } from '@ducks/conectoresConexoes';

export default function TableConexoes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const conexoes = useSelector(({ conectoresConexoes }) => conectoresConexoes.get('conexoes').toArray());
  const loadingConexoes = useSelector(({ conectoresConexoes }) => conectoresConexoes.get('loadingConexoes'));

  const handleSearch = () => {
    dispatch(getConexoes(id));
  };

  const handleReset = () => {
    dispatch(resetConexoes());
  };

  useEffect(() => {
    handleReset();
  }, []);

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Conexão',
      dataIndex: 'ds',
      key: 'ds',
      render: (text, item) => (
        <View>
          {item.ds} - {item.banco}
        </View>
      ),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '7%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/configuracao/${item.idConfiguracao}/conexao/${item.id}`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='id' columns={columns} dataSource={conexoes} loading={loadingConexoes} hidePagination />;
}
